(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
  const getpagi = document.querySelector('.AjaxinatePagination');
  if (typeof getpagi !== 'undefined' && getpagi !== null) {
    document.addEventListener('DOMContentLoaded', function () {
      const elem = getpagi.getAttribute('data-pagination');
      new Ajaxinate({
        container:   '.AjaxinateLoop',
        pagination:  '.AjaxinatePagination',
        loadingText: '<div class="cp-spinner" style="margin:20px auto;"></div>',
        method:      elem === 'scroll' ? 'scroll' : 'click'
      });
    });
  }

  document.querySelectorAll('.js-btn-view').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const col  = this.getAttribute('data-col');
      const grid = document.getElementById('product-grid');
      if (!grid) return;
      grid.classList.remove('cols-2', 'cols-3', 'cols-4');
      grid.classList.add('cols-' + col);
      document.querySelectorAll('.js-btn-view').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(),
                       window.SPR.initRatingHandler(),
                       window.SPR.initDomEls(),
                       window.SPR.loadProducts(),
                       window.SPR.loadBadges();
              }
            }
          })
          .catch(e => console.error(e));
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 500px 0px' }).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
